import { addData } from '@/actions/auth';
import LandingLayout from '@/components/landing/home/LandingLayout';
import MainBanner from '@/components/landing/home/MainBanner';
import { Row } from 'antd';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Signup = () => {
  const dispatch = useDispatch();
  const [needBanner, setNeedBanner] = useState(false);
  const partnerData = useSelector((state: any) => state?.auth?.partner?.data);

  const isLogin = () => {
    const token = window.localStorage.getItem('token');
    if (token) {
      window.location.pathname = '/';
    } else {
      dispatch(
        addData({
          key: 'isLoggedIn',
          value: false,
        })
      );
    }
  };

  useEffect(() => {
    isLogin();
  }, []);

  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE_URL}signup`} />
      </Head>
      <LandingLayout>
        <div className="ptb-100 login-content">
          {partnerData?.register_name && needBanner && (
            <Row
              gutter={[10, 0]}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: '10000',
                backgroundColor: 'rgba(60,60,60,0.5)',
              }}
            >
              <Row>
                <p
                  style={{
                    color: 'white',
                    fontSize: '16px',
                    textTransform: 'capitalize',
                  }}
                  className="p-1 px-3"
                >
                  Provided For {partnerData?.register_name}
                </p>
              </Row>
            </Row>
          )}

          <MainBanner backgroundColorWhite mission={''} isSignUpPage={true} />
        </div>
      </LandingLayout>
    </>
  );
};

export default Signup;
